// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1NuG2","title":"ClientReferral_title__1YZIz","itemText":"ClientReferral_itemText__3wYSb"};